import Box from "@mui/material/Box";
import type React from "react";
import Loader from "../../sharedComponents/Loader/Loader";

interface PreloaderOuterContainerProps {
	isLoading: boolean;
	children: React.ReactNode;
}

const PreloaderOuterContainer: React.FC<PreloaderOuterContainerProps> = ({
	isLoading,
	children,
}) => (
	<Box
		sx={{
			width: "100%",
			height: "100vh",
			display: isLoading ? "flex" : "none",
			justifyContent: "center",
			alignItems: "center",
			overflow: "hidden",
			position: "relative",
			bgcolor: "transparent",
		}}
	>
		{children}
	</Box>
);

interface PreloadPageProps {
	isLoading: boolean;
}

function PreloadPage({ isLoading }: PreloadPageProps) {
	return (
		<PreloaderOuterContainer isLoading={isLoading}>
			<Loader position={"0"} />
		</PreloaderOuterContainer>
	);
}

export default PreloadPage;
